import { ProcedureSummary } from '@/components/dashboard/ProcedureSummary';
import { Header } from '@/components/header';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_operator/subjects/$subjectId/procedures/$procedureId/summary/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { procedureId } = Route.useParams();

  return (
    <div className="bg-fill-surface-strong flex-1 flex flex-col min-h-0">
      <div className="mb-space-lg">
        <Header />
      </div>

      <ProcedureSummary procedureId={ procedureId } />
    </div>
  );
}
